module.exports = __webpack_public_path__ + "img/dyegos.7cb78d3b.jpg";